import { getPolyglot } from '../../../../../i18n';
import Link from '../../../../../theme/components/Link';
import React from 'react';
import { StyledMenuItemPrimary } from '../../../../../components/App/header/AvatarMenu/AvatarMenu';

export const FWAvatarLinks = () => {
  const urlAboutUs = 'https://structuralconcepts.com/';

  const polyglot = getPolyglot();
  return (
    <>
      <Link to={urlAboutUs} target="_blank">
        <StyledMenuItemPrimary>
          {polyglot.t('footer.about_us')}
        </StyledMenuItemPrimary>
      </Link>
    </>
  );
};
